<template>
  <div>
    <nav
      class="bg-white dark:bg-blueDianne-1000 top-0 h-[90px] fixed z-10 w-full flex flex-wrap navbar-expand-lg items-center"
    >
      <div
        class="container flex justify-between max-w-full sm:max-w-[1200px] mx-auto h-12 items-center px-5"
      >
        <div class="flex items-center shrink-0 px-2">
          <a
            :href="marketingBaseUrl"
            class="text-white text-sm font-bold leading-relaxed inline-block whitespace-nowrap uppercase"
          >
            <img
              v-if="isDark"
              src="/img/notedsource-logo-footer.svg"
              class="w-[220px] sm:w-[310px] h-auto"
              alt="NotedSource"
            />
            <img
              v-else
              src="/img/notedsource-logo.svg"
              class="w-[220px] sm:w-[310px] h-auto"
              alt="NotedSource"
            />
          </a>
        </div>
        <div class="flex items-center justify-end flex-1">
          <button
            class="text-blueDianne dark:text-white focus:outline-none"
            aria-label="Toggle Dark Mode"
            @click="toggleDark()"
          >
            <i v-if="isDark" class="fas fa-sun text-xl"></i>
            <i v-else class="fas fa-moon text-xl"></i>
          </button>
          <div class="hidden sm:flex justify-end pl-5 items-center">
            <template v-if="$store.getters.isCheckingAuth">
              <i class="fas fa-circle-notch fa-spin mr-3 text-blueGray-300"></i>
            </template>
            <template v-else-if="!$store.getters.isPersonLoggedIn">
              <div class="flex">
                <a :href="`${webBaseUrl}`">
                  <div
                    class="flex items-end rounded-l-full rounded-b-full cursor-pointer px-12 py-2 text-blueDianne bg-puertoRico hover:bg-puertoRico-500 transition-all duration-500 font-bold"
                  >
                    <h6 class="font-headline text-xl">Login</h6>
                  </div>
                </a>
              </div>
            </template>
            <template v-else>
              <div class="mb-3 mt-2 pt-2 hidden md:block">
                <div class="mx-auto max-w-[200px]">
                  <div class="flex items-center">
                    <user-dropdown
                      :allow-dropdown="true"
                      :profile-image-size="30"
                    />
                    <div class="ml-3 overflow-x-hidden">
                      <p class="block text-sm dark:text-white">
                        Hello, {{ $store.getters.person.firstName }}
                      </p>
                      <p
                        class="text-xs text-blueGray-400 dark:text-blueGray-300 max-w-full overflow-x-hidden text-ellipsis"
                      >
                        {{ $store.getters.person.calc_EmailAddress }}
                      </p>
                      <p
                        v-if="$store.getters.isImpersonating"
                        class="text-xs text-black hidden sm:block whitespace-nowrap bg-orange-200 px-1 py-0 mb-2 overflow-x-hidden text-ellipsis"
                      >
                        <em
                          >Impersonated by
                          {{ $store.getters.isImpersonating }}</em
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import UserDropdown from "../UserDropdown.vue";

export default {
  components: {
    UserDropdown,
  },
  data() {
    return {
      isDark: false,
      webBaseUrl: import.meta.env.VITE_WEB_BASE_URL,
      marketingBaseUrl: import.meta.env.VITE_BASE_URL,
      adminBaseUrl: import.meta.env.VITE_ADMIN_BASE_URL,
    };
  },
  mounted() {
    this.isDark =
      localStorage.getItem("theme") === "dark" ||
      (!("theme" in localStorage) &&
        window.matchMedia("(prefers-color-scheme: dark)").matches);
    if (this.isDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  },
  methods: {
    toggleDark() {
      this.isDark = !this.isDark;
      if (this.isDark) {
        document.documentElement.classList.add("dark");
        localStorage.setItem("theme", "dark");
      } else {
        document.documentElement.classList.remove("dark");
        localStorage.setItem("theme", "light");
      }
    },
  },
};
</script>
